import { User } from 'models/user';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
    setShowSidebar: (val: boolean) => void;
    currentUser: User;
};

const ShowSideBarController: React.FC<Props> = ({ setShowSidebar, currentUser }) => {
    let location = useLocation();

    useEffect(() => {
        if(!currentUser) setShowSidebar(false);

        const tempShowSideBar = 
        location.pathname !== "/login"
        && !location.pathname.includes("/register")
        && location.pathname !== "/forgot-password"
        && location.pathname !== "/reset-password";
    
        setShowSidebar(tempShowSideBar);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location, currentUser]);

    return (null);
}

export default ShowSideBarController;